import { Text } from '@doda/io-react/common';
import { PageTitle } from '@doda/io-react/pc';
import { useAppSelector } from 'redux/hooks';
import { seoTextSelector } from '@doda/common/src/redux/features/seoText';
import { getSeoText } from '@doda/common/src/logics/seoText/getSeoText';
import { FC } from 'react';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import parse from 'html-react-parser';
import Link from 'next/link';
import { makeStaticUrl } from '@doda/common/src/logics/staticUrl';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { DEFAULT_SEO_TITLE, DEFAULT_TITLE } from '../../constants';
import styles from './index.module.scss';

/**
 * BodyTitleのProps
 * @param explainText タイトル下説明文
 */
interface Props {
  explainText: string | null;
}

export const BodyTitle: FC<Props> = ({ explainText }) => {
  const query = useAppSelector(appQueryParamsSelector);
  const { pr, ci, wa, st, page, nearArea, baseArea } = query;
  const seoText = getSeoText(useAppSelector(seoTextSelector));
  const pageCount = page ? `${page}ページ：` : '';
  const pageTitle = seoText.titleOrText;

  const baseUrl = makeStaticUrl(
    {
      pr: pr ? baseArea : undefined,
      ci: ci ? baseArea : undefined,
      wa: wa ? baseArea : undefined,
      st: st ? baseArea : undefined,
      preBtn: '1',
    },
    DODA_SITE_URL.jobSearchList
  );

  return (
    <div className={styles.bodyTitle__wrapper}>
      <PageTitle>
        {pageTitle === DEFAULT_SEO_TITLE
          ? DEFAULT_TITLE
          : parse(
              `${pageCount}${pageTitle}&nbsp;${query.nearArea ? '近隣エリア' : ''}の転職・求人検索結果`
            )}
      </PageTitle>
      {explainText && (
        <Text as="p" color="gray" size="12" weight="normal">
          {parse(explainText)}
        </Text>
      )}
      {nearArea && (
        <div className={styles.bodyTitle__nearArea}>
          <Text>[元の検索条件]</Text>
          <Link className={styles.bodyTitle__link} href={baseUrl}>
            {seoText.titleOrText} の転職・求人情報はこちら
          </Link>
        </div>
      )}
    </div>
  );
};
